export default {"src":"/_next/static/media/material-symbols-mail-rounded.1e3b2c82.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};